import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {useContext} from 'react'
import {isHydrated} from '../utils/utils'
import {CONTEXT_NOT_PROVIDED} from '../constants'

const HydrationContext = React.createContext(CONTEXT_NOT_PROVIDED)

const HydrationProvider = ({children}) => {
    const [hydrated, setHydrated] = useState(() => isHydrated())

    useEffect(() => {
        if (!hydrated) {
            let unmounted = false
            let animationFrameId = null

            const checkHydrated = () => {
                if (unmounted) return

                if (isHydrated()) {
                    setHydrated(true)
                } else {
                    animationFrameId = requestAnimationFrame(checkHydrated)
                }
            }

            checkHydrated()
            return () => {
                unmounted = true
                if (animationFrameId !== null) {
                    cancelAnimationFrame(animationFrameId)
                }
            }
        }
    }, [hydrated])

    return <HydrationContext.Provider value={hydrated}>{children}</HydrationContext.Provider>
}

HydrationProvider.propTypes = {
    children: PropTypes.node.isRequired
}

const useHydration = () => {
    const context = useContext(HydrationContext)
    if (context === CONTEXT_NOT_PROVIDED) {
        throw new Error('HydrationContext must be used inside HydrationProvider')
    }

    return context
}

export {HydrationProvider}
export default useHydration
